import React from 'react';
import { getInputId, getAcceptAttribute } from './FilePicker.Helpers';
import Spinner from "../../../components/Common/Spinner/Spinner";

interface FileInputProps {
    uniqueName: string;
    maxFileCount: number;
    allowedExtensions: string[];
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    showSpinner?: boolean;
}

class FileInput extends React.Component<FileInputProps> {

    render(): JSX.Element {
        return (
            <div className='display-flex align-items-center justify-content-center'>
                <label htmlFor={getInputId(this.props.uniqueName)}>Choose file</label>
                {this.props.showSpinner &&
                    < Spinner />
                }
                <input
                    onClick={() => this.setState({ showSpinner: true })}
                    type="file"
                    id={getInputId(this.props.uniqueName)}
                    accept={getAcceptAttribute(this.props.allowedExtensions)}
                    multiple={this.props.maxFileCount > 0}
                    onChange={this.props.onChange}
                    style={{ display: "none" }} />
            </div>
        );
    }
}

export default FileInput;

